module.exports = __webpack_public_path__ + "img/cns_printer_pc7.eec4c733.png";